import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './Icon.js';
import { Text } from './Text.js';
/** The surface everything sits on. */
export function Card({ children, elevation = 'sm', padding = 'lg', className, as: Component = 'div', interactive = false, labelledBy, }) {
    const classes = [
        'lh-card',
        elevation === 'flat' && 'lh-card--flat',
        elevation === 'md' && 'lh-card--raised',
        interactive && 'lh-card--interactive',
        `lh-card--pad-${padding}`,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { className: classes, "aria-labelledby": labelledBy, children: children }));
}
export function CardHeader({ title, description, action, as = 'h2', icon, id }) {
    return (_jsxs("div", { className: "lh-card__header", children: [_jsxs("div", { className: "lh-inline lh-inline--nowrap lh-gap-sm lh-grow", children: [icon && (_jsx("span", { className: "lh-icon-tile", "aria-hidden": "true", children: _jsx(Icon, { name: icon, size: 18 }) })), _jsxs("div", { className: "lh-stack lh-gap-hair lh-grow", children: [_jsx(Text, { variant: "title", as: as, id: id, children: title }), description && (_jsx(Text, { variant: "bodySm", tone: "secondary", children: description }))] })] }), action] }));
}
export function CardBody({ children }) {
    return _jsx("div", { className: "lh-card__body", children: children });
}
export function CardFooter({ children }) {
    return _jsx("div", { className: "lh-card__footer", children: children });
}
//# sourceMappingURL=Card.js.map